// ═══════════════════════════════════════════════════════════════════
//  modules/sanctions/constantes.js
//  Libellés et couleurs. Les DURÉES ne sont pas ici : elles viennent
//  du barème servi par le backend, pour qu'il n'existe qu'une seule
//  source de vérité (CDC §1).
// ═══════════════════════════════════════════════════════════════════

import { THEME } from "../../socle/theme";

export const NIVEAU_STYLE = {
  kick:     { label: "Kick",           icone: "👢", color: THEME.textMuted, bg: THEME.surface },
  mute:     { label: "Mute",           icone: "🔇", color: THEME.amber,     bg: THEME.amberDim },
  ban_temp: { label: "Ban temporaire", icone: "⛔", color: THEME.red,       bg: THEME.redDim },
  ban_def:  { label: "Ban définitif",  icone: "🚫", color: "#FF7B72",       bg: THEME.redDim },
};

export const STATUT_STYLE = {
  active:  { label: "En cours", color: THEME.red,       bg: THEME.redDim },
  expiree: { label: "Expirée",  color: THEME.textMuted, bg: THEME.surface },
  levee:   { label: "Levée",    color: THEME.emerald,   bg: THEME.emeraldDim },
};

export const DOSSIER_STYLE = {
  observation:   { label: "Observation",   color: THEME.accent,    bg: THEME.accentDim },
  liste_blanche: { label: "Liste blanche", color: THEME.emerald,   bg: THEME.emeraldDim },
  ban_propose:   { label: "Ban proposé",   color: THEME.amber,     bg: THEME.amberDim },
  ban_applique:  { label: "Ban appliqué",  color: THEME.red,       bg: THEME.redDim },
  sans_suite:    { label: "Sans suite",    color: THEME.textMuted, bg: THEME.surface },
};

export const GRADE_LABEL = { 1: "Guide", 2: "Modérateur", 3: "Admin", 4: "Fondateur" };

export function dureeLisible(minutes) {
  if (minutes == null) return "définitif";
  if (minutes === 0) return "immédiat";
  if (minutes < 60) return `${minutes} min`;
  if (minutes < 1440) return `${Math.round(minutes / 60)} h`;
  return `${Math.round(minutes / 1440)} j`;
}

export function dateCourte(v) {
  if (!v) return "—";
  return new Date(v).toLocaleString("fr-FR", { day: "2-digit", month: "2-digit", year: "2-digit", hour: "2-digit", minute: "2-digit" });
}

export function tempsRestant(expire) {
  if (!expire) return null;
  const ms = new Date(expire) - new Date();
  if (ms <= 0) return "terminé";
  const h = Math.floor(ms / 3600000);
  if (h < 1) return `${Math.ceil(ms / 60000)} min`;
  if (h < 48) return `${h} h`;
  return `${Math.floor(h / 24)} j`;
}
